export const PROJECT_SEARCH_BAR_BUTTON = 'project-search-bar-button'
